<template>
  <layout title="Classrooms">
    <form>
      <div class="form-group">
        <h4>
          <label for="status_update">Post to classroom</label>
        </h4>

        <form @submit.prevent="postMessage">
          <div class="form-group row">
            <div class="col-sm-12">
              <textarea
                name="message"
                rows="3"
                class="form-control"
                v-model="form.message"
              ></textarea>
              <div
                v-if="errors && errors.message"
                class="d-block invalid-feedback"
              >
                {{ errors.message }}
              </div>
              <small id="emailHelp" class="form-text text-muted">
                Your message will be shared with all the students in the
                classroom.
              </small>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-12">
              <button type="submit" class="btn btn-primary float-right">
                Share
              </button>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col-md-12">
            <FlashMessage :flash="flash" />
          </div>
        </div>

        <Post v-for="post in posts" :key="post.id" :post="post" :canDelete="authUser.id == post.user.id || authUser.id == classroom.data.teacher.id" @delete="showDeleteConfirmationModal" />
      </div>
    </form>


        <div
      class="modal fade"
      id="deleteConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Delete Post
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to delete this post?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="confirmDelete(selectedRecord ? selectedRecord.id : null)"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>


  </layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import ClassroomLayout from "../../Layouts/ClassroomLayout";
import Post from "../../../Components/ClassroomPost";

export default {
  layout: [AppLayout, ClassroomLayout],
  props: {
    classroom: Object,
    flash: Object,
    errors: Object,
    posts: Object,
    authUser: Object
  },
  components: {
    Post: Post,
  },
  data() {
    return {
      selectedRecord: null,
      form: {
        message: "",
      },
    };
  },
  methods: {
    postMessage() {
      if (this.form.message) {
        this.$inertia.post(
          route(
            "classrooms.assigned.view.overview.post.store",
            this.classroom.data.id
          ),
          this.form,
          {
            onFinish: () => {
              this.form.message = "";
            },
          }
        );
      }
    },

    showDeleteConfirmationModal(post) {
      this.selectedRecord = post;
      $("#deleteConfirmationModal").modal("show");
    },
    confirmDelete(id) {
      this.$inertia.delete(route("classrooms.assigned.view.overview.post.destroy", [this.classroom.data.id, id]));
    },
  },
};
</script>